export var Name = 'remove-voucher';
export var RemoveVoucherEvent = Name;